import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { putCommType } from '../features/templateSlice'
import TemplateService from '../services/templateService'

/**
 * Open a template in the shared preview dialog (`components/TemplatePreview`,
 * rendered once on the page that uses this hook). The same two steps the
 * template library takes: set the channel the dialog renders for, then load
 * the body, which opens the dialog (or shows why it could not load).
 *
 * @returns {(templateId: string, commType: string) => void} does nothing
 *   without a template id
 */
const useTemplatePreview = () => {
    const dispatch = useDispatch()
    return useCallback(
        (templateId, commType) => {
            if (!templateId) return
            dispatch(putCommType(commType))
            dispatch(TemplateService.getTemplateData(templateId))
        },
        [dispatch]
    )
}

export default useTemplatePreview
